import React from 'react';
import {Helmet} from 'react-helmet';
import {Banner} from '@shopify/polaris';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {useQuery} from '@shopify/react-graphql';
import {
  RequireAuth,
  AppLayout,
} from 'sections/services-marketplace/experts/components';
import {PageBanner, Filters, Results} from './components';
import GetProfiles from 'sections/services-marketplace/experts/sections/expert-index/graphql/GetProfilesQuery.graphql';
import i18nArgs from './locales';

interface OwnProps {}
type CombinedProps = OwnProps & WithI18nProps;

function SavedExperts({i18n}: CombinedProps) {
  const {loading, data, error} = useQuery(GetProfiles, {
    variables: {
      filters: {
        serviceHandle: 'design_custom_email_templates',
      },
      after: '0',
    },
  });

  const ErrorBanner = (
    <Banner status="critical">
      {i18n.translate('SavedExperts.ErrorBanner.content')}
    </Banner>
  );

  return (
    <RequireAuth>
      <Helmet>
        <title>{i18n.translate('SavedExperts.Meta.title')}</title>
        <meta
          name="description"
          content={i18n.translate('SavedExperts.Meta.description')}
        />
      </Helmet>
      <AppLayout>
        <AppLayout.Container>
          <AppLayout.Section fill>
            <PageBanner />
          </AppLayout.Section>
        </AppLayout.Container>
        <AppLayout.Container>
          <AppLayout.Section size="OneFifth">
            <Filters />
          </AppLayout.Section>
          <AppLayout.Section fill>
            {error ? (
              ErrorBanner
            ) : (
              <Results
                loading={loading}
                profiles={data && data.profiles}
                serviceHandle="design_custom_email_templates"
              />
            )}
          </AppLayout.Section>
        </AppLayout.Container>
      </AppLayout>
    </RequireAuth>
  );
}

export default withI18n(i18nArgs)(SavedExperts);
